var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.$store.state.fullScreenOrNot ? _vm.scrollClass1 : _vm.scrollClass,attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"sc-1ri0y0w-7 lFKjX"},[_c('div',{staticClass:"sc-1ri0y0w-2 fzkKCz",style:(_vm.svgBg)})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }